import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { ROOT, SUBSCRIBERS, USER_PROFILE } from '../../constants/routes';
import API from '../../API';
import Loader from '../../components/Loader';
import Avatar from '../../components/Avatar';
import { LoadMoreButton } from 'components/generic-components/LoadMoreButton';

const SubscribeList = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(1);

  const { t } = useTranslation();
  const location = useLocation();
  useEffect(() => {
    getData();
  }, []);
  const getData = (page = 1) => {
    let type = location.pathname === SUBSCRIBERS ? 'followers' : 'follows';

    setIsLoading(true);
    API.get('follows-and-followers', { type, page })
      .then(resp => {
        console.log('data', resp);
        setData(page === 1 ? resp.data : [...data, ...resp.data]);
        setPage(resp.meta.current_page);
        setLastPage(resp.meta.last_page);
        setTotal(resp.meta.total);
        setIsLoading(false);
      })
      .catch(errors => {
        console.log(errors);
        setIsLoading(false);
      });
  };
  const loadMore = () => {
    getData(page + 1);
  };
  return (
    <div className={'col-12 px-3 py-4'} style={{ background: '#fff', minHeight: '100%' }}>
      <Loader isLoadin={isLoading && !data.length} height={17} size={16}>
        <h4 className="text-gray">
          {t('Total')}: {total}
        </h4>
        <hr />
        {data.map(el => {
          let user = el.user;
          return (
            <Link
              key={el.id}
              className="d-flex align-items-center h5"
              to={USER_PROFILE.replace(':userId?', user.id).replace(':name?', !!user.nickname ? user.nickname : '')}
            >
              <Avatar size={40} image={user.avatar} />
              <p className="ml-3 font-weight-bold text-black">{user.name}</p>
              {'\u00A0'}
              {!!user.nickname && <p className="text-light-gray">@{user.nickname}</p>}
            </Link>
          );
        })}
        {(page < lastPage || (page == lastPage && isLoading)) && (
          <Loader isLoadin={isLoading} height={36} size={28}>
            <LoadMoreButton handleLoadMore={loadMore} />
          </Loader>
        )}
      </Loader>
    </div>
  );
};

export default SubscribeList;
